import React, { useState, useEffect } from "react";
import windowsIcon from "../../../assets/images/windows-icon.png";
import linuxIcon from "../../../assets/images/linux-icon.png";
import ApiCalls from "../../apis/api-calls";

const DiagnosticModal = () => {
  const [diagnosticModal, setDiagnosticModal] = useState(false);
  const [urls, setUrls] = useState({});

  useEffect(() => {
    ApiCalls.getDiagnosticUrls()
      .then(res => {
        if (res.status_code === 200) {
          setUrls(res.data);
        }
      })
      .catch(err => {
        console.log(err);
      });
  }, []);

  const diagnosticPopup = value => {
    setDiagnosticModal(value);
  };

  const handleDownload = (e, key) => {
    e.preventDefault();
    if (key === 0) {
      downloadFile(urls.windows);
    }
    if (key === 1) {
      downloadFile(urls.unix);
    }
  };

  const downloadFile = url => {
    let link = document.createElement("a");
    link.setAttribute("download", null);
    link.style.display = "none";
    document.body.appendChild(link);
    link.setAttribute("href", url);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <div>
      <div>
        <div className="upgrade_head_wrapper">
          <div className="left_head_wrapper">
            <strong>About this version</strong>
          </div>
          <div className="right_head_wrapper">
            Troubleshooting?{" "}
            <span className="dwn-ut_txt" onClick={e => diagnosticPopup(true)}>
              Download
            </span>{" "}
            our Diagnostic Utillity
          </div>
        </div>
      </div>
      {diagnosticModal && (
        <div className="diag_modal">
          <div className="modalWrapper diag_modal_wrapper">
            <div className="modalHeader">
              Diagnostic Utility
              <span onClick={e => diagnosticPopup(false)}>X</span>
            </div>
            <div className="modalBody">
              <h3>About</h3>
              <p>
                This Utility is self contained and will execute as a console
                application from within the Izenda API service deployment
                location. The Utility will retrieve sample data and report
                definition files and will consolidate all generated outputs and
                log files into the archive "out.zip" for transmittal to Izenda
                Staff.
              </p>
              <p>
                For use and instructions, please use the{" "}
                <a href={urls.readme} target="_blank">
                  README
                </a>
                .
              </p>
              <div className="dwn_container">
                <div className="downloadText">
                  Which version would you like to download?
                </div>
                <div
                  name="windows"
                  className="windowsBtn"
                  onClick={e => handleDownload(e, 0)}
                >
                  <span className="IconSpan">
                    <img src={windowsIcon} alt="" className="ButtonIcon" />
                  </span>
                  Windows
                </div>
                <div
                  name="linux"
                  className="windowsBtn linux-btn"
                  onClick={e => handleDownload(e, 1)}
                >
                  <span className="IconSpan">
                    <img src={linuxIcon} alt="" className="ButtonIcon" />
                  </span>
                  Linux
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default DiagnosticModal;



// WEBPACK FOOTER //
// ./src/components/Profile/UpgradeComponent/DiagnosticModal.js